import { render, staticRenderFns } from "./waitset.vue?vue&type=template&id=2942e85a&scoped=true&"
import script from "./waitset.vue?vue&type=script&lang=js&"
export * from "./waitset.vue?vue&type=script&lang=js&"
import style0 from "./waitset.vue?vue&type=style&index=0&id=2942e85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942e85a",
  null
  
)

export default component.exports